import * as R from 'remeda';
import { AnnotationStatus } from '@rossum/api-client/shared';
import { AsyncTasks, ImportTask, UnprocessedDocuments } from '../TaskContext';
import { TaskInfo } from './getTaskDialogTitle';

type ClassifyTasksParams = {
  asyncTasks: AsyncTasks;
  unprocessedDocuments: UnprocessedDocuments;
  importTasks: ImportTask[];
  uploadedAnnotations?: {
    annotationUrl: string;
    annotationStatus: AnnotationStatus;
  }[];
  childAnnotations?: {
    annotationStatus: AnnotationStatus;
  }[];
};

export const classifyTasks = ({
  asyncTasks,
  unprocessedDocuments,
  importTasks,
  uploadedAnnotations,
  childAnnotations,
}: ClassifyTasksParams): TaskInfo[] => {
  return [
    ...asyncTasks
      .map<TaskInfo | undefined>(({ data }) => data)
      .filter(R.isDefined),
    ...unprocessedDocuments.map<TaskInfo>(() => ({
      type: 'upload_created',
      status: 'failed',
    })),
    ...importTasks.map<TaskInfo>(({ annotationUrl }) => {
      const status = uploadedAnnotations?.find(
        annotation => annotation.annotationUrl === annotationUrl
      )?.annotationStatus;

      return {
        type: 'import',
        status:
          status && status !== 'importing'
            ? status === 'failed_import'
              ? 'failed'
              : 'succeeded'
            : 'running',
      };
    }),
    ...(childAnnotations ?? []).map<TaskInfo>(
      ({ annotationStatus: status }) => {
        return {
          type: 'import',
          status:
            status && status !== 'importing'
              ? status === 'failed_import'
                ? 'failed'
                : 'succeeded'
              : 'running',
        };
      }
    ),
  ];
};
